module.exports = __webpack_public_path__ + "static/media/box-link2.3e83b518.png";